import { useContext } from 'react';

import { BalanceNotificationContext } from './BalanceNotificationContext';

export const useBalanceNotificationContext = () => useContext(BalanceNotificationContext);
